<div class="min-h-screen bg-gray-50 flex flex-col">

  <!-- Header -->
  <header class="bg-white border-b border-gray-100 shadow-sm">
    <div class="max-w-4xl mx-auto px-4 py-4 flex items-center gap-3">
      <a routerLink="/recrutement"><img src="assets/images/logo-couleur_1@4x.png" alt="Agodjie" class="h-10 w-auto"></a>
      <div class="ml-auto">
        <a routerLink="/recrutement" class="text-sm text-ag-red font-semibold hover:underline">← Toutes les offres</a>
      </div>
    </div>
  </header>

  <main class="flex-1">
    <div class="max-w-4xl mx-auto px-4 py-8">
      <app-loading [isVisible]="loading"></app-loading>

      @if (notFound) {
        <div class="text-center py-16">
          <p class="text-gray-500">Cette offre n'est pas disponible ou a été clôturée.</p>
          <a routerLink="/recrutement" class="inline-block mt-3 text-ag-red font-semibold hover:underline">Voir les autres offres</a>
        </div>
      }

      @if (offer) {
        <!-- Détail de l'offre -->
        <div class="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
          <div class="flex items-start justify-between gap-3">
            <h1 class="text-2xl font-bold text-gray-900 m-0">{{offer.title}}</h1>
            @if (offer.contract_type) {
              <span class="shrink-0 px-3 py-1 rounded-full bg-ag-red/10 text-ag-red text-sm font-semibold">{{offer.contract_type}}</span>
            }
          </div>

          <div class="flex flex-wrap items-center gap-2 mt-3 text-sm text-gray-500">
            @if (offer.category) { <span class="px-2 py-0.5 rounded-full bg-gray-100">{{offer.category}}</span> }
            @if (offer.location) { <span>📍 {{offer.location}}</span> }
            @if (offer.positions) { <span>{{offer.positions}} poste(s)</span> }
            @if (offer.deadline) { <span>Limite : {{offer.deadline | date:'dd/MM/yyyy'}}</span> }
          </div>

          @if (offer.salary_min || offer.salary_max) {
            <p class="text-sm text-gray-600 mt-3 mb-0">
              Rémunération :
              @if (offer.salary_min) { <span>{{offer.salary_min | number}} FCFA</span> }
              @if (offer.salary_min && offer.salary_max) { <span> – </span> }
              @if (offer.salary_max) { <span>{{offer.salary_max | number}} FCFA</span> }
            </p>
          }

          <div class="mt-5">
            <h3 class="text-sm font-bold text-gray-800 uppercase">Description</h3>
            <p class="text-sm text-gray-600 whitespace-pre-line mt-1 mb-0">{{offer.description}}</p>
          </div>

          @if (offer.profile_required) {
            <div class="mt-5">
              <h3 class="text-sm font-bold text-gray-800 uppercase">Profil recherché</h3>
              <p class="text-sm text-gray-600 whitespace-pre-line mt-1 mb-0">{{offer.profile_required}}</p>
            </div>
          }
        </div>

        <!-- Formulaire / Succès -->
        <div class="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm mt-6">
          @if (submitted) {
            <div class="text-center py-8">
              <div class="mx-auto w-14 h-14 rounded-full bg-green-100 text-green-600 flex items-center justify-center text-2xl">✓</div>
              <h3 class="text-lg font-bold text-gray-900 mt-3 mb-1">Candidature envoyée !</h3>
              <p class="text-sm text-gray-500 m-0">Merci pour votre intérêt. Nous reviendrons vers vous après étude de votre dossier.</p>
              <a routerLink="/recrutement" class="inline-block mt-4 px-4 py-2 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold">Voir d'autres offres</a>
            </div>
          } @else {
            <h2 class="text-lg font-bold text-gray-900 m-0 pl-3 border-l-4 border-ag-red">Postuler à cette offre</h2>

            @if (errorMessage) {
              <p class="mt-3 mb-0 px-3 py-2 rounded-lg bg-red-50 text-ag-red text-sm">{{errorMessage}}</p>
            }

            <form #f="ngForm" (ngSubmit)="submit()" class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <div>
                <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Prénom *</label>
                <input name="firstname" [(ngModel)]="form.firstname" required
                       class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10">
              </div>
              <div>
                <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Nom *</label>
                <input name="lastname" [(ngModel)]="form.lastname" required
                       class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10">
              </div>
              <div>
                <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Email *</label>
                <input name="email" type="email" [(ngModel)]="form.email" required
                       class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10">
              </div>
              <div>
                <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Téléphone *</label>
                <input name="phone" [(ngModel)]="form.phone" required
                       class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10">
              </div>
              <div>
                <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Niveau d'études</label>
                <select name="education_level" [(ngModel)]="form.education_level"
                        class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
                  <option value="">— Choisir —</option>
                  @for (l of EDUCATION_LEVELS; track l) { <option [value]="l">{{l}}</option> }
                </select>
              </div>
              <div>
                <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Années d'expérience</label>
                <input name="years_experience" type="number" min="0" [(ngModel)]="form.years_experience"
                       class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
              </div>
              <div class="md:col-span-2">
                <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Lettre de motivation</label>
                <textarea name="cover_letter" rows="4" [(ngModel)]="form.cover_letter"
                          class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10"></textarea>
              </div>
              <div class="md:col-span-2">
                <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">CV (PDF / Word) *</label>
                <input type="file" accept=".pdf,.doc,.docx" (change)="onFileSelected($event)"
                       class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red file:mr-3 file:px-3 file:py-1 file:rounded-md file:border-0 file:bg-ag-red file:text-white file:text-xs file:font-semibold">
              </div>
              <div class="md:col-span-2 flex justify-end">
                <button type="submit" [disabled]="f.invalid || submitting"
                        class="px-5 py-2.5 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold disabled:opacity-50 inline-flex items-center gap-2">
                  Envoyer ma candidature <app-loading [isVisible]="submitting"></app-loading>
                </button>
              </div>
            </form>
          }
        </div>
      }
    </div>
  </main>

  <footer class="bg-white border-t border-gray-100">
    <div class="max-w-4xl mx-auto px-4 py-6 text-center text-xs text-gray-400">
      © {{ 2025 }} Agodjie — Tous droits réservés.
    </div>
  </footer>
</div>
